import styled from '@emotion/styled';

const BasicLink = styled.a`
  label: BasicLink;

  color: ${props =>
    props.infoText ? 'var(--colors-trout)' : 'var(--colors-orange-base)'};

  text-transform: ${props => (props.capitalize ? 'capitalize' : 'none')};

  &:hover {
    text-decoration: underline;
  }
`;

export default BasicLink;
